/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { YoutubeVideoConfigInfoRespVo } from './YoutubeVideoConfigInfoRespVo';
import {
    YoutubeVideoConfigInfoRespVoFromJSON,
    YoutubeVideoConfigInfoRespVoFromJSONTyped,
    YoutubeVideoConfigInfoRespVoToJSON,
    YoutubeVideoConfigInfoRespVoToJSONTyped,
} from './YoutubeVideoConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseYoutubeVideoConfigInfoRespVo
 */
export interface ResponseYoutubeVideoConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseYoutubeVideoConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseYoutubeVideoConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {YoutubeVideoConfigInfoRespVo}
     * @memberof ResponseYoutubeVideoConfigInfoRespVo
     */
    data?: YoutubeVideoConfigInfoRespVo;
}

/**
 * Check if a given object implements the ResponseYoutubeVideoConfigInfoRespVo interface.
 */
export function instanceOfResponseYoutubeVideoConfigInfoRespVo(value: object): value is ResponseYoutubeVideoConfigInfoRespVo {
    return true;
}

export function ResponseYoutubeVideoConfigInfoRespVoFromJSON(json: any): ResponseYoutubeVideoConfigInfoRespVo {
    return ResponseYoutubeVideoConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponseYoutubeVideoConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseYoutubeVideoConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : YoutubeVideoConfigInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseYoutubeVideoConfigInfoRespVoToJSON(json: any): ResponseYoutubeVideoConfigInfoRespVo {
    return ResponseYoutubeVideoConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponseYoutubeVideoConfigInfoRespVoToJSONTyped(value?: ResponseYoutubeVideoConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': YoutubeVideoConfigInfoRespVoToJSON(value['data']),
    };
}

